// src/api/carApi.js
import api from './index';


export const getGptCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gptCarpage_gpt_submai', params, config);
};


export const getGptAPICarList = (params = {}, config = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gpt_gpt_api_Carpage_gpt_submai', params, config);
};

export const getGrokCarList = (params = {}, config = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/grokCarpage_grok_submain', params, config);
};


export const getSoraCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/soraCarpage_sora_submain', params, config);
  };


export const getMJCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/mjCarpage_mj_submain', params, config);
};


export const getCCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/claudeCarpage_claude_submain', params, config);
};

export const getClaudeV2CarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/claudeCarpage_aimonkeyVip_submain', params, config);
};

export const getGeminiCarList = (params = {}, config = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/geminiCarpage_gemini_submain', params, config);
};